import { Dialog } from '@mui/material';
import React from 'react';
import { subHeadingStyle } from 'views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
const PrListing = ({ open, setOpen, rows, title = "PR Listing", searchPrHandler, prWarningData }) => {
  const closeDialog = () => {
    setOpen(false);
  }
  return (
    <Dialog open={open} fullwidth maxWidth="300px">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-end">
          {/* <QuestionMarkIcon /> */}
          <CrossIcon onClick={closeDialog} />
        </div>
        <div style={{ width: '440px' }}>
          <div className="header d-flex justify-content-center">{title}</div>
          <table className="table table-striped">
            <tr>
              {/* <div style={subHeadingStyle}>PR Listing</div> */}
              {
                prWarningData ? <td className='mt-1 d-flex justify-content-center cursor link'>{prWarningData}</td> : rows?.map((item, index) => (
                  <td style={subHeadingStyle} className='mt-1 d-flex justify-content-center cursor link' onClick={() => searchPrHandler(item?.Pr_no)} key={`${item?.Pr_no}-${index}`}>{item?.Pr_no}</td>
                ))
              }
            </tr>
          </table>

        </div>
      </div>
    </Dialog>
  );

}
export default PrListing